import { DrawenLayerGroupResultType } from 'src/types/components/draw-module.type';
import { drawenLayerGroupService } from 'src/app/services';
import { errorLocals } from 'src/locals';
import { statusHelper, hymotsLogsSocketHelper } from '.';

const getDrawGroups = async (tarafId: number | undefined) => {
  try {
    return await drawenLayerGroupService.drawenLayerGroupLookup(tarafId);
  } catch (error) {
    if (error !== errorLocals.errorHandledError) {
      // statusHelper.displayErrorMessage(
      //   'Failed to fetch map data from Hymots. Please check your connection or try again later.',
      //   3,
      // );
      console.log(error, 'error');
    }
  }
};

const getDrawGroup = async (id: number) => {
  try {
    const response = await drawenLayerGroupService.drawenLayerGroupSingleLookup(id);
    return response.data;
  } catch (error) {
    if (error !== errorLocals.errorHandledError) {
      statusHelper.displayErrorMessage(
        'Failed to fetch map data from Hymots. Please check your onnection or try again later.',
        3,
      );
    }
  }
};

// GATEWAY SOCKET
// SOKET LAYER CREATE
const socketLayerGroupCreateEvent = async (
  payload: DrawenLayerGroupResultType,
  setDrawGroupState: (value: React.SetStateAction<DrawenLayerGroupResultType[]>) => void,
) => {
  try {
    setDrawGroupState((current) => {
      if (!current.some((o) => o.id === payload.id)) {
        return [...current, payload];
      }
      return current;
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

// GRUP ADI GÜNCELLEME
const socketLayerGroupEditEvent = async (
  payload: DrawenLayerGroupResultType,
  setDrawGroupsState: React.Dispatch<React.SetStateAction<DrawenLayerGroupResultType[]>>,
  drawController?: any,
  userRole?: string,
) => {
  try {
    drawController?.setPublishedLayers?.();

    setDrawGroupsState((current) => {
      const exists = current.some((g) => g.id === payload.id);
      return exists ? current.map((g) => (g.id === payload.id ? payload : g)) : [...current, payload];
    });
    drawController?.drawGroups?.add(payload);
  } catch (err) {
    console.error('socketLayerGroupEditEvent error', err);
  }
};

// SOKET LAYER DELETE
const socketLayerGroupDeleteEvent = async (
  deleteData: number,
  setDrawGroupState: (value: React.SetStateAction<DrawenLayerGroupResultType[]>) => void,
  socketOnGroupDelete: (id: number) => void,
) => {
  try {
    if (deleteData) {
      setDrawGroupState((current) => current.filter((y) => y.id !== deleteData));
      socketOnGroupDelete(deleteData);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

const drawGroupSocketCallbackCreate = (
  data: any,
  setDrawGroupState: (value: React.SetStateAction<DrawenLayerGroupResultType[]>) => void,
) => {
  switch (data.status) {
    case 'ADD':
      socketLayerGroupCreateEvent(data.data, setDrawGroupState);
      break;
    default:
      break;
  }
};

const drawGroupSocketCallbackUpdateDelete = (
  data: any,
  setDrawGroupState: (value: React.SetStateAction<DrawenLayerGroupResultType[]>) => void,
  socketOnGroupDelete: (id: number) => void,
  drawController: any,
  userRole: string,
) => {
  switch (data.status) {
    case 'ADD':
      socketLayerGroupCreateEvent(data.data, setDrawGroupState);
      break;
    case 'DELETE':
      socketLayerGroupDeleteEvent(data.data, setDrawGroupState, socketOnGroupDelete);
      break;
    case 'UPDATE':
      socketLayerGroupEditEvent(data.data, setDrawGroupState, drawController, userRole);
      break;
    default:
      break;
  }
};

const createDrawGroupSocketConnection = async (
  setDrawGroupState: (value: React.SetStateAction<DrawenLayerGroupResultType[]>) => void,
  drawGroups: DrawenLayerGroupResultType[],
  socketOnGroupDelete: (id: number) => void,
  veritabaniId: number,
  drawController?: any,
  tarafId?: number,
  userRole?: string,
) => {
  const conStringCreate = `drawen-layer-group_${veritabaniId}${tarafId ? `_${tarafId}` : ``}`;
  const conStringUpdateDelete = `drawen-layer-group_${veritabaniId}`;

  hymotsLogsSocketHelper.listenSocket(conStringCreate, (data) =>
    drawGroupSocketCallbackCreate(data, setDrawGroupState),
  );
  hymotsLogsSocketHelper.listenSocket(conStringUpdateDelete, (data) =>
    drawGroupSocketCallbackUpdateDelete(data, setDrawGroupState, socketOnGroupDelete, drawController, userRole || ''),
  );
};
export { getDrawGroups, createDrawGroupSocketConnection, getDrawGroup };
